import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { DICTS, LangProvider } from "@/i18n";
import { LANGS, DEFAULT_LANG, keyFromSlug } from "@/i18n/routes";
import SmoothScroll from "@/components/SmoothScroll";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import Seo from "@/components/Seo";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Activities from "@/pages/Activities";
import Projects from "@/pages/Projects";
import LaRomana from "@/pages/LaRomana";
import Villa from "@/pages/Villa";
import Team from "@/pages/Team";
import Gallery from "@/pages/Gallery";
import Donate from "@/pages/Donate";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import { AuthProvider, Protected } from "@/admin/auth";
import AdminLogin from "@/admin/AdminLogin";
import AdminMessages from "@/admin/AdminMessages";

const PAGES = {
  home: Home, about: About, activities: Activities, projects: Projects, laRomana: LaRomana, villa: Villa,
  team: Team, gallery: Gallery, donate: Donate, contact: Contact, privacy: Legal, cookies: Legal, notFound: NotFound,
};

const LangRoot = () => {
  const params = useParams();
  const { pathname } = useLocation();
  const lang = params.lang;

  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);

  if (!LANGS.includes(lang)) return <Navigate to={`/${DEFAULT_LANG}/`} replace />;
  const pageKey = keyFromSlug(lang, params["*"]) || "notFound";
  const Page = PAGES[pageKey];

  return (
    <LangProvider value={{ lang, t: DICTS[lang], pageKey }}>
      <Seo />
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] btn btn-yellow">{DICTS[lang].nav.skip}</a>
      <Header />
      <main id="main" data-testid={`page-${pageKey}`}>
        <Page key={pageKey} />
      </main>
      <Footer />
      <CookieBanner />
    </LangProvider>
  );
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <SmoothScroll />
        <Routes>
          <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}/`} replace />} />
          <Route path="/admin/login" element={<AuthProvider><AdminLogin /></AuthProvider>} />
          <Route path="/admin" element={<AuthProvider><Protected><AdminMessages /></Protected></AuthProvider>} />
          <Route path="/:lang/*" element={<LangRoot />} />
        </Routes>
        <Toaster position="bottom-center" />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
